export default "__VITE_ASSET__CTIRgHcF__"